export function isCustomElementActionMenuItem(item) {
  return item === null || item === void 0 ? void 0 : item.isCustomContent;
}
export function isDividerActionMenuItem(item) {
  return item === null || item === void 0 ? void 0 : item.isDivider;
}
export function isGroupHeadingActionMenuItem(item) {
  return item === null || item === void 0 ? void 0 : item.isGroupHeading;
}
export function isRegularAcctionMenuItem(item) {
  return !isCustomElementActionMenuItem(item) && !isDividerActionMenuItem(item) && !isGroupHeadingActionMenuItem(item);
}